import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.attributes({
        checkboxesSelector: ':checkbox',
    });

    this.updateCheckboxes = function() {
        if (this.$checkboxes.filter(':checked').length >= this.$node.data('max-selection')) {
            var $unchecked = this.$checkboxes.filter(':not(:checked)');
            $unchecked.closest('.field').attr('data-field-disabled', '');
            $unchecked.prop('disabled', true);
        } else {
            this.$checkboxes.closest('.field').removeAttr('data-field-disabled');
            this.$checkboxes.prop('disabled', false);
        }
    };

    this.after('initialize', function() {
        this.$checkboxes = this.select('checkboxesSelector');
        this.updateCheckboxes();
        this.on('change', {
            checkboxesSelector: this.updateCheckboxes,
        });
    });
});



// WEBPACK FOOTER //
// ./src/web/js/app/modules/logo-type.js